import { render, staticRenderFns } from "./AddManualEvent.vue?vue&type=template&id=1f5a4664&scoped=true"
import script from "./AddManualEvent.vue?vue&type=script&lang=js"
export * from "./AddManualEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a4664",
  null
  
)

export default component.exports